/**
 * FINANCES (Matt, 2026-11-03): one workspace for the money tools, Bookkeeping first and Billing
 * second, opened from the one "Finances" item in the left menu. Each tab is still its own workspace
 * underneath (FinanceWorkspace.jsx ?ws=finance, BillingWorkspace.jsx ?ws=billing, so their URLs, saved
 * state and activity logging are unchanged); this strip sits in both headers and switches between
 * them. A tab shows only to the person who holds its module (finance-admin, billing-admin).
 */
import { workspaceTabsWrapStyle, workspaceTabStyle } from './WorkspaceChrome.jsx'
import { hasModule, isSeatLoaded } from '../services/tenancy.js'
import { ctx } from '../outline/ctx.js'

export const canBookkeeping = () => isSeatLoaded() && hasModule('finance-admin')
export const canBillingTab = () => isSeatLoaded() && hasModule('billing-admin')

/** Open the Finances workspace on a tab ('bookkeeping' | 'billing'), or its first tab you can see. */
export function openFinances(tab) {
  const t = tab || (canBookkeeping() ? 'bookkeeping' : 'billing')
  ctx.closeAllWorkspaces()
  if (t === 'bookkeeping') window.dispatchEvent(new CustomEvent('open-finance'))
  else window.dispatchEvent(new CustomEvent('open-billing', { detail: { tool: 'readiness' } }))
}

export default function FinancesTabs({ current }) {
  const tabs = [
    canBookkeeping() && ['bookkeeping', 'Bookkeeping'],
    canBillingTab() && ['billing', 'Billing'],
  ].filter(Boolean)
  if (tabs.length < 2) return null
  return (
    <div style={workspaceTabsWrapStyle}>
      {tabs.map(([k, label]) => (
        <button key={k} style={workspaceTabStyle(current === k)} onClick={() => { if (current !== k) openFinances(k) }}>{label}</button>
      ))}
    </div>
  )
}
